import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllConversations, selectNewConversation } from '@reducers/data/nexus';
import Section from '@components/Section';
import { SpeechBubbleIcon, XIcon } from '@components/Icons';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { clearNewConversation, deleteConversation } from '@actions/nexus';
import cn from 'classnames';
import styles from './ConversationHistory.module.scss';
import { ID } from '@app/types';

export default function ChatConversationHistory({
  setConversationTargetContactID,
}: {
  setConversationTargetContactID: Dispatch<ID>;
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { conversationID } = useParams<{ conversationID: string }>();
  const conversations = useSelector(selectAllConversations);
  const newChatConversation = useSelector(selectNewConversation);
  let newConversationBtnDisabled =
    !newChatConversation.messages.last().error &&
    location.pathname === '/nexus' &&
    !newChatConversation.isPersisted;

  if (newChatConversation.paywalled || newChatConversation.nexusDisabled) {
    newConversationBtnDisabled = false;
  }

  return (
    <Section className="content-container">
      <Section.Title underline listItem IconComponent={SpeechBubbleIcon}>
        Conversations
      </Section.Title>
      <div className={styles.conversationList}>
        {conversations.map((conversation) => {
          return (
            <div
              key={conversation.id}
              className={cn(
                styles.conversation,
                conversation.id === conversationID && styles.active,
              )}
            >
              <Link
                className={styles.conversationLink}
                to={`/nexus/${conversation.id}`}
                onClick={() => {
                  if (!conversationID) {
                    dispatch(clearNewConversation);
                  }
                }}
              >
                {conversation.messages.first().text}
              </Link>
              <XIcon
                className={styles.clearConversationBtn}
                width={14}
                height={14}
                strokeWidth={1.6}
                hoverOpacity
                onClick={() => {
                  dispatch(deleteConversation(conversation.id));
                  if (location.pathname.includes(conversation.id)) {
                    setConversationTargetContactID(null);
                    navigate('/nexus');
                  }
                }}
              />
            </div>
          );
        })}

        <button
          className={cn(styles.newConversationBtn, 'btn btn-none')}
          onClick={() => {
            dispatch(clearNewConversation);
            setConversationTargetContactID(null);
            if (location.pathname !== '/nexus') {
              navigate('/nexus');
            }
          }}
          disabled={newConversationBtnDisabled}
        >
          New Conversation
        </button>
      </div>
    </Section>
  );
}
